<template>
  <div class="chat">
    <img src="../assets/标题@2x.png" alt="" srcset="" class="chat_title_img">
    <div class="chat_query_backgroud">
      <div class="chat_query_backgroud1">
        <div>
          <div class="chat_query_title">搜索城市寻找社群~</div>
          <div class="chat_query_title">
          </div>
          和我们一起搭建属于你的社群吧~
        </div>
        <!-- <div class="chat_query_input">
          <img src="../assets/地标@2x.png" alt="" srcset="" class="chat_location_icon">
        </div> -->
        <el-input placeholder="输入城市" v-model="query_city">
          <i class="el-icon-place" slot="prepend">{{ location }}</i>
          <el-button slot="append" icon="el-icon-search" @click="query_confirm"></el-button>
        </el-input>
        <div class="chat_button" @click="centerDialogVisible = true">
          <span>我要做社群</span>
          <img src="../assets/箭头@2x.png" alt="" class="chat_do">
        </div>
      </div>
    </div>
    <div class="chat_query_backgroud">
      <div class="chat_query_backgroud2">
        <div class="chat_country">- 本地社群 -</div>
        <el-table :data="chat_records_ip">
          <el-table-column prop="chatName" label="社群" align="left" show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column prop="province" label="省" align="center" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column prop="city" label="市" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="chatNum" label="人数" align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="chat_query_backgroud">
      <div class="chat_query_backgroud2">
        <div class="chat_country">- 全国社群 -</div>
        <el-table :data="chat_records">
          <el-table-column prop="chatName" label="社群" align="left" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="province" label="省" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="city" label="市" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="chatNum" label="人数" align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <img src="../assets/入群须知1.png" alt="" srcset="" class="chat_join_img">
    <img src="../assets/入群须知2.png" alt="" srcset="" class="chat_join_img">
    <img src="../assets/入群须知3.png" alt="" srcset="" class="chat_join_img">
    <img src="../assets/入群须知4.png" alt="" srcset="" class="chat_join_img">

    <el-dialog :visible.sync="centerDialogVisible" width="90%" center top="7vh">
      <img src="../assets/service.jpg" alt="" srcset="" class="chat_join_img">
      <div style="text-align: center;">长按扫码添加小助手好友建群</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  mounted() {
    this.getLocation();
    this.chat_list_ip();
    this.chat_list();
  },
  data() {
    return {
      location: null,
      chat_records_ip: [],
      query_city: null,
      chat_records: [],
      centerDialogVisible: false
    }
  },
  methods: {
    getLocation() {
      this.axios.get('/cgmChat/getLocationByIP', {
        params: {
        }
      }).then((res) => {
        this.location = res.data.data
      }).catch((error) => {
        console.log(error);
      })
    },
    chat_list_ip() {
      this.axios.get('/cgmChat/getCityByIP', {
        params: {
        }
      }).then((res) => {
        this.chat_records_ip = res.data.data
      }).catch((error) => {
        console.log(error);
      })
    },
    chat_list() {
      this.axios.get('/cgmChat/list', {
        params: {
          city: this.query_city
        }
      }).then((res) => {
        this.chat_records = res.data.data
      }).catch((error) => {
        console.log(error);
      })
    },
    query_confirm() {
      this.chat_list();
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: "PingFang";
  src: url("../assets/PingFang Regular.ttf");
}

* {
  box-sizing: border-box;
  font-family: "PingFang";
}

.chat {
  /* background-image: url(../assets/底图@2x.png); */
  width: 100%;
  height: 100%;
  position: absolute;
  background: url(../assets/底图@2x.png);
  background-size: 100% 100%;
}

.chat_title_img {
  width: 100%;
}

.chat_query_backgroud {
  width: 100%;
  padding: 5px 5px;
}

.chat_query_backgroud1 {
  width: 100%;
  padding: 20px;
  background: #FFFFFF;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chat_query_backgroud1 div {
  margin: 10px;
}

.chat_query_backgroud2 {
  width: 100%;
  padding: 20px;
  background: #FFFFFF;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chat_query_title {
  text-align: center;
}

.chat_query_input {
  width: 90%;
  height: 40px;
  line-height: 40px;
  background: #F4F4F4;
  border-radius: 20px;
  border: 1px solid #999AC4;
  padding: 0 10px;
}

.chat_location_icon {
  width: 4%;
}

.chat_button {
  width: 90%;
  background: #1E2087;
  border-radius: 10px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
}

.chat_do {
  width: 4%;
  vertical-align: middle;
}

.chat_country {
  color: #1E2087;
  font-weight: 600;
  font-size: 18px;
}

.chat_join_img {
  width: 100%;
  vertical-align: top
}
</style>
